import { createSlice } from '@reduxjs/toolkit'
import { getCoinActions, getCoinHistory } from '../actions/coinsActions'

const initialState = {
	actions: {
		data: [],
		isLoading: false,
		error: null,
	},
	history: {
		data: [],
		pagination: null,
		currentType: null,
		isLoading: false,
		error: null,
	},
}

const coinsSlice = createSlice({
	name: 'coins',
	initialState,
	reducers: {
		clearHistory: (state) => {
			state.history.data = []
			state.history.pagination = null
			state.history.currentType = null
		},
	},
	extraReducers: (builder) => {
		// Get coin actions
		builder.addCase(getCoinActions.pending, (state) => {
			state.actions.isLoading = true
			state.actions.error = null
		})
		builder.addCase(getCoinActions.fulfilled, (state, action) => {
			state.actions.isLoading = false
			state.actions.error = null
			state.actions.data = action.payload
		})
		builder.addCase(getCoinActions.rejected, (state, action) => {
			state.actions.isLoading = false
			state.actions.error = action.error.message
		})

		// Get coin history
		builder.addCase(getCoinHistory.pending, (state, action) => {
			// Only set loading if it's not an append operation
			if (!action.meta.arg?.append) {
				state.history.isLoading = true
			}
			state.history.error = null
		})
		builder.addCase(getCoinHistory.fulfilled, (state, action) => {
			state.history.isLoading = false
			state.history.error = null
			
			const { data, pagination, append, type, page } = action.payload
			
			// If it's a new filter type or first page without append, replace data
			if (!append || page === 1 || state.history.currentType !== type) {
				state.history.data = data || []
				state.history.currentType = type
			} else if (append && page > 1 && state.history.currentType === type) {
				// Append new data, merging date groups
				const existingData = state.history.data || []
				const newData = data || []
				
				// Merge groups by date
				const mergedData = [...existingData]
				newData.forEach((newGroup) => {
					const existingGroupIndex = mergedData.findIndex(
						(g) => g.date === newGroup.date
					)
					if (existingGroupIndex >= 0) {
						// Merge transactions for the same date
						mergedData[existingGroupIndex].transactions = [
							...mergedData[existingGroupIndex].transactions,
							...newGroup.transactions,
						]
					} else {
						// Add new date group
						mergedData.push(newGroup)
					}
				})
				state.history.data = mergedData
			}
			
			state.history.pagination = pagination
		})
		builder.addCase(getCoinHistory.rejected, (state, action) => {
			state.history.isLoading = false
			state.history.error = action.error.message
		})
	},
})

export const { clearHistory } = coinsSlice.actions
export default coinsSlice.reducer

